<script lang="ts">
// import Logo from '@/assets/images/logo-ng.svg';
import Logo from '@/assets/images/mini-logo.svg';

export default defineComponent({
	name: "VLogo",

	props: {
		width: {
			default: "200",
		}
	},
	data: () => ({
		Logo,
	})
});
</script>

<template>
	<img alt="Logo" :style="`max-width: ${width}px;`" :src="Logo"/>
</template>

